import { render, staticRenderFns } from "./RankGoodsOfDistributor.vue?vue&type=template&id=a3521d98&scoped=true"
import script from "./RankGoodsOfDistributor.vue?vue&type=script&lang=js"
export * from "./RankGoodsOfDistributor.vue?vue&type=script&lang=js"
import style0 from "./RankGoodsOfDistributor.vue?vue&type=style&index=0&id=a3521d98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3521d98",
  null
  
)

export default component.exports